// ============================================================================
// Table Columns: Roles
// Key: roles
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
	objectRenderer,
	relationCountRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	PermissionSummary,
	RolePermissionDto,
	RoleSummary,
	UserDto,
	UserRoleDto,
} from '../api/backstage.schemas'
import {
	ApplicationScope,
	EntityScope,
	PermissionName,
} from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const rolesListColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		enumRenderer('entityScope', EntityScope, 'EntityScope'),
		enumRenderer('applicationScope', ApplicationScope, 'ApplicationScope'),
		cellRenderer('isDefault', 'boolean'),
		cellRenderer('isBaseRole', 'boolean'),
		objectRenderer('userGroup', 'name'),
		relationCountRenderer('permissionCount', 'permissions'),
		relationCountRenderer('userCount', 'users'),
		cellRenderer('templateCount', 'number'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: RoleSummary) => `/roles/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<RoleSummary>
// #endregion

// #region Relation List Columns
// #region Relation: Permissions
export const rolesRelationsPermissionsAssignedColumnsConfig = {
	columns: [
		'roleName',
		enumRenderer('permissionName', PermissionName, 'PermissionName'),
	],
} as const satisfies EntityTableConfig<RolePermissionDto>
export const rolesRelationsPermissionsAvailableColumnsConfig = {
	columns: [
		enumRenderer('name', PermissionName, 'PermissionName'),
		cellRenderer('roleCount', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
} as const satisfies EntityTableConfig<PermissionSummary>
// #endregion

// #region Relation: Users
export const rolesRelationsUsersAssignedColumnsConfig = {
	columns: [
		'roleName',
		enumRenderer('roleEntityScope', EntityScope, 'EntityScope'),
		enumRenderer('roleApplicationScope', ApplicationScope, 'ApplicationScope'),
		cellRenderer('isRoleDefault', 'boolean'),
		'userFirstName',
		'userLastName',
		'userEmail',
		'userLogonName',
		cellRenderer('isManuallyAssigned', 'boolean'),
	],
} as const satisfies EntityTableConfig<UserRoleDto>
export const rolesRelationsUsersAvailableColumnsConfig = {
	columns: [
		'firstName',
		'lastName',
		'email',
		cellRenderer('isDisabled', 'boolean'),
		'logonName',
		'extension',
		'customProperty1',
		'customProperty2',
		'customProperty3',
		'customProperty4',
		'customProperty5',
	],
} as const satisfies EntityTableConfig<UserDto>
// #endregion
// #endregion

// #region Columns Config Export
export const rolesColumnsConfig = {
	list: rolesListColumnsConfig,
	relations: {
		permissions: {
			assigned: rolesRelationsPermissionsAssignedColumnsConfig,
			available: rolesRelationsPermissionsAvailableColumnsConfig,
		},
		users: {
			assigned: rolesRelationsUsersAssignedColumnsConfig,
			available: rolesRelationsUsersAvailableColumnsConfig,
		},
	},
} as const
// #endregion
